// ======================================================================
// File Name       : SelectGroupModal
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { change } from 'redux-form';
import { Modal, Form, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { MESSAGE_TYPE, MESSAGE_TIME_OUT, MODAL_SIZE } from '../constants/index';
import TreeView from '../components/Tree';
import ModalWrapper from '../components/modal/ModalWrapper';
import * as groupActions from '../actions/GroupAction';
import * as Functions from '../constants/FunctionConstants';
import TREE_ICON from '../images/tree/default-icon.png';
import { canAccess } from '../utils/AuthedUtils';
import RenderField from '../utils/ReduxFormUtils';
import { showLoading, hideLoading } from '../utils/PageUtils';
import { createTree } from '../utils/groupUtils';

class SelectGroupModal extends React.Component {
  constructor(props) {
    super(props);
    this.onOK = this.onOK.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
  }

  componentWillMount() {
    if (!this.props.allSecernIds || !this.props.bySecernId || this.props.allSecernIds.length <= 0) {
      this.props.dispatch(groupActions.fetchGroupStructure());
    }
  }

  onOK() {
    const { formKey, treeCheckBox } = this.props;
    const form = this.props.form[formKey];
    if (form && form.values) {
      const { selectedTargetGroupIds, selectedTargetGroup } = form.values;
      if (!treeCheckBox) {
        this.props.dispatch(groupActions.selectedGroupOnDialog(selectedTargetGroup));
      } else {
        this.props.dispatch(groupActions.selectedGroupIdsOnDialog(selectedTargetGroupIds));
      }
    }
    this.props.hideModal();
  }

  onCancel() {
    const { selectedTargetGroup, treeCheckBox } = this.props;
    if (!treeCheckBox) {
      this.props.dispatch(change(this.props.formKey, 'selectedTargetGroup', null));
    } else {
      this.props.dispatch(change(this.props.formKey, 'selectedTargetGroupIds', selectedTargetGroup));
    }
    this.props.hideModal();
  }

  getModalOptions() {
    return {
      title: 'ユーザーグループを選択してください',
      footerBtns: [
        { name: 'キャンセル', onClick: this.onCancel, variant: 'default' },
        { name: 'OK', onClick: this.onOK, variant: 'primary' },
      ],
    };
  }

  render() {
    const { selectedTargetGroup, groupList } = this.props;
    const nodes = createTree(groupList, false, selectedTargetGroup);
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.onCancel}>
        <Col sm={12}>
          <RenderField name={this.props.treeCheckBox ? 'selectedTargetGroupIds' : 'selectedTargetGroup'} data={nodes} type="tree" treeCheckBox={this.props.treeCheckBox} />
        </Col>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { selectedTargetGroupIds, selectedTargetGroup } = state.group;
  const { structures, groupList } = state.group;
  const form = state.form;
  return { selectedTargetGroupIds, selectedTargetGroup, form, ...structures, groupList };
};

export default connect(mapStateToProps)(SelectGroupModal);
